// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-quality-dropdown-container {
  display: flex;

  width: max-content;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;

  position: absolute;
  z-index: 999;
  right: 0px;
  bottom: 44px;

  border-radius: 8px;
  border: 1px solid var(--color-Border-Basic-2, #e5e4e7);
  background: #fff;

  /* Shadow-Lower-2 */
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
}

.video-quality-dropdown-row {
  cursor: pointer;

  display: flex;
  width: 81px;
  height: 30px;

  align-items: center;
  justify-content: center;
  column-gap: 6px;

  gap: 6px;

  > span {
    flex-shrink: 0;
    color: var(--color-Content-1, #39383d);

    /* pre/body/08 */
    font-family: 'Pretendard Variable';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 18.2px */
    letter-spacing: -0.26px;
  }

  &:hover {
    border-radius: 6px;
    background: var(--color-background-basic-2, #f7f7f8);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/happyCall/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;EAEb,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;;EAER,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;;EAEZ,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;;EAEhB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;;EAEf,aAAa;EACb,WAAW;EACX,YAAY;;EAEZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;;EAEf,QAAQ;;EAER;IACE,cAAc;IACd,sCAAsC;;IAEtC,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;IAC9B,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,oDAAoD;EACtD;AACF","sourcesContent":[".video-quality-dropdown-container {\r\n  display: flex;\r\n\r\n  width: max-content;\r\n  padding: 4px;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 2px;\r\n\r\n  position: absolute;\r\n  z-index: 999;\r\n  right: 0px;\r\n  bottom: 44px;\r\n\r\n  border-radius: 8px;\r\n  border: 1px solid var(--color-Border-Basic-2, #e5e4e7);\r\n  background: #fff;\r\n\r\n  /* Shadow-Lower-2 */\r\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.video-quality-dropdown-row {\r\n  cursor: pointer;\r\n\r\n  display: flex;\r\n  width: 81px;\r\n  height: 30px;\r\n\r\n  align-items: center;\r\n  justify-content: center;\r\n  column-gap: 6px;\r\n\r\n  gap: 6px;\r\n\r\n  > span {\r\n    flex-shrink: 0;\r\n    color: var(--color-Content-1, #39383d);\r\n\r\n    /* pre/body/08 */\r\n    font-family: 'Pretendard Variable';\r\n    font-size: 13px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 140%; /* 18.2px */\r\n    letter-spacing: -0.26px;\r\n  }\r\n\r\n  &:hover {\r\n    border-radius: 6px;\r\n    background: var(--color-background-basic-2, #f7f7f8);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
